<template>
    <main>
        <ContentDoc />
    </main>
</template>